<template>
  <v-card class="dialog">
    <v-card-title class="primary">
      <h3 class="headline" style="padding-left: 16px">
        SOLICITAÇÃO DE COTAÇÃO
      </h3>
    </v-card-title>

    <div>
      <v-card-text flex>
        <v-card class="pa-0" style="background: none" flat>
          <v-card-text>
            <h3
              style="color: #555555; font-weight: 500; font-size: 16px; font-family:'Roboto Medium', 'Roboto Regular', 'Roboto', sans-serif;"
            >
              Informe os dados do segurado:
            </h3>
            <v-form
              ref="formulario"
              v-model="formCorretorValidado"
              @submit.prevent
              class="content"
            >
              <v-flex>
                <v-text-field
                  label="Razão Social"
                  browser-autocomplete="off"
                  required
                  v-model="corretor.razaoSocial"
                  :rules="regras.notNull"
                >
                </v-text-field>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex>
                <v-select
                  label="Tipo Pessoa"
                  item-text="titulo"
                  item-value="id"
                  v-model="corretor.idTipoPessoa"
                  :items="tipoPessoaList"
                  required
                >
                </v-select>
              </v-flex>

              <v-spacer></v-spacer>
              <v-flex>
                <v-text-field
                  browser-autocomplete="off"
                  required
                  :mask="
                    this.corretor.idTipoPessoa === 1
                      ? '###.###.###-##'
                      : 'NN.NNN.NNN/NNNN-##'
                  "
                  :label="{ 1: 'CPF', 2: 'CNPJ' }[corretor.idTipoPessoa] || 'CPF/CNPJ'"
                  v-model="corretor.cnpj"
                  :rules="this.corretor.idTipoPessoa === 1 ? regras.cpf : formRulesComputed.transportadora.cnpj(corretor.cnpj)"
                  :disabled="!corretor.idTipoPessoa"
                >
                </v-text-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex>
              <v-select
                label="Tipo Seguro"
                browser-autocomplete="off"
                required
                :items="propostaTipoList"
                v-model="corretor.idPropostaTipo"
                item-text="titulo"
                item-value="id"
                :rules="regras.notNull"
              >
              </v-select>
            </v-flex>
              <v-spacer></v-spacer>
              <v-flex >
                <v-select v-show = "corretor.idPropostaTipo == 2 || corretor.idPropostaTipo == 1"
                  label="Companhia de renovação"
                  browser-autocomplete="off"
                  required
                  item-text="titulo"
                  item-value="id"
                  :items="ciaRenovacaoList"
                  v-model="corretor.idCiaRenovacao"
                  :rules="regras.notNull"
                >
                </v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex>
                <v-menu
                  ref="menu"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  :rules="regras.notNull"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field v-show = "corretor.idPropostaTipo == 2 || corretor.idPropostaTipo == 1"
                      v-model="textInicio"
                      label="Data da vigência"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      required
                      :rules="regras.notNull"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="corretor.dataVencimentoApolice"
                    @change="onDateChange"
                    no-title
                    scrollable
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-layout>
                <v-flex>
                  <v-radio-group
                    v-model="corretor.detentorApolice"
                    class="my-0 pt-0"
                  >
                    <span>Você é detentor da apólice?</span>
                    <v-layout>
                      <v-flex
                        d-flex
                        align-center
                        v-for="item in simOuNao"
                        :key="item.titulo"
                        v-model="corretor.detentorApolice"
                      >
                        <v-radio
                          style="color: #555555"
                          class="radio-inputs-cotacao"
                          :label="item.titulo"
                          :value="item.value"
                          :rules="regras.notNull"
                          required
                        >
                        </v-radio>
                      </v-flex>
                    </v-layout>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-form>

          </v-card-text>
        </v-card>

        <v-layout v-if="mostrarBloqueio" wrap>
          <v-flex xs12>
            <div class="bloqueio-alerta">
              <v-icon color="orange darken-2">warning</v-icon>
              <span>O CPF/CNPJ informado não atende aos critérios de conformidade exigidos para a continuidade do processo.</span>
            </div>
            <div style="text-align: right; margin-top: 8px;">
              <v-btn class="button-custom" flat @click="mostrarBloqueio = false; $emit('fechar')">FECHAR</v-btn>
            </div>
          </v-flex>
        </v-layout>

        <v-card-actions class="pb-5" v-if="!mostrarBloqueio">
          <v-layout row>
            <v-flex xs12 md4>
              <v-btn color="primary" flat @click="fecharDialog()">
                CANCELAR
              </v-btn>
            </v-flex>
            <v-flex xs12 md4F offset-md4>
              <v-btn
                style="font-weight: 500"
                class="button-custom"
                flat
                @click="proximaPagina"
                :disabled="disable"
                >PRÓXIMO
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card-text>
    </div>

    <v-layout row justify-center>
      <template>
        <v-layout row justify-center>
          <v-dialog v-model="dialogCotacaoAnexo" max-width="727px" persistent>
            <v-card class="dialog">
              <v-card-title class="primary">
                <span class="headline" style="padding-left: 16px">
                  SOLICITAÇÃO DE COTAÇÃO</span
                >
              </v-card-title>
              <v-card-text class="px-4">
                <div grid-list-md>
                  <v-layout wrap>
                    <v-flex align-center d-flex xs12 sm6 md3>
                      <a flat @click="salvarPlanilhaModelo">
                        Baixar Modelo de Excel
                      </a>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <label
                        for="file-upload"
                        :class="['button-custom', { disabled: loading }]"
                      >
                        ARQUIVO
                      </label>
                      <input
                        @change="processarArquivo($event)"
                        id="file-upload"
                        type="file"
                        @click="$event.target.value = ''"
                        :disabled="loading"
                        v-if="dialogFile"
                      />
                    </v-flex>
                    <v-flex xs12 md7 class="pl-4">
                      <input
                        type="text"
                        class="name-arquivo"
                        v-model="arquivo.name"
                      />
                      <v-progress-circular
                        v-if="loading"
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </v-flex>
                  </v-layout>
                </div>
                <div class="my-3" v-if="!arquivoValido">
                  <p class="relatorio-erros-titulo">Relatorio erros:</p>
                  <div class="border-container">
                    <p class="text-error-custom">
                      {{
                        arquivoFaltante.length
                          ? `${
                              arquivoFaltante.length === 1
                                ? "A coluna"
                                : "As colunas"
                            } "${arquivoFaltante.join('", "')}" ${
                              arquivoFaltante.length === 1
                                ? "não foi encontrada"
                                : "não foram encontradas"
                            }`
                          : "Erro ao processar o arquivo."
                      }}
                    </p>

                    <p class="text-error-custom" >{{
                      erro === undefined || null
                        ? "Não foi possível importar o documento."
                        : formatarMensagemErroPlanilha(erro)
                    }}</p>


                </div>

                </div>
              </v-card-text>

              <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
                {{ snackText }}
                <v-btn flat @click="snack = false">Fechar</v-btn>
              </v-snackbar>

              <v-card-actions class="px-5 pb-5">

                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="voltarDialogAnexo"
                  >VOLTAR
                </v-btn>

                <v-btn
                  color="primary"
                  :disabled="!arquivo.name || !cnpjValido"
                  @click="submeterArquivoPlanilha"
                >
                  IMPORTAR PLANILHA
                </v-btn>
              </v-card-actions>

            </v-card>
          </v-dialog>
        </v-layout>
      </template>
      <v-dialog persistent v-model="dialogInfoCotacao" max-width="1350px">
        <ModalInfoCotacao
          @voltar="dialogInfoCotacao = false"
          :planilhaValida="arquivoValido"
          @atualizar="modalAtualizar"
          :dadosCotacaoReserva="this.corretor"
          :clickImportar="clickImportar"
          :inicioVigencia="corretor.dataVencimentoApolice"
          @fechar="
            dialogInfoCotacao = dialogCotacaoAnexo = false;
            $emit('fechar');
          "
        ></ModalInfoCotacao>
      </v-dialog>
      <v-dialog persistent v-model="dialogProgress" max-width="800px">
        <v-card class="dialog">
          <v-card-title class="primary">
            <span class="headline">AVALIANDO ITENS</span>
          </v-card-title>
          <v-card-text class="py-5 px-4">
            <div grid-list-md>
              <v-layout wrap>
                <v-flex align-center d-flex xs12>
                  <span>
                    Por favor, aguarde o processamento. Isso pode levar alguns
                    minutos
                  </span>
                </v-flex>
                <v-flex align-center d-flex xs12>
                  <v-progress-linear
                    heigth="2px"
                    indeterminate
                    color="primary"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>

          <v-card-actions class="px-4 pb-5">
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialogProgress = false"
              >CANCELAR
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="mostrarDialogRestricaoTecnica" max-width="570px">
        <ModalRestricaoTecnica
          :mostrarMensagemCompleta = "true"
          @fecharDialogModalRestricaoTecnica="
            mostrarDialogRestricaoTecnica = false;
            $emit('fecharDialogModalRestricaoTecnica');
          ">
        </ModalRestricaoTecnica>
      </v-dialog>
    </v-layout>
  </v-card>
</template>
<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalInfoCotacao from "./ModalInfoCotacao.vue";
import formRules from "@/helpers/form-rules";
import validadores from "@/helpers/validadores";
import ModalRestricaoTecnica from "./ModalRestricaoTecnica.vue";

export default {
  name: "ModalCotacao",
  components: {
    ModalInfoCotacao: ModalInfoCotacao,
    ModalRestricaoTecnica: ModalRestricaoTecnica
  },
  data: () => ({
    textoLivreAnexo: null,
    menu1: false,
    dialogCotacaoAnexo: false,
    tabs: null,
    arquivo: {},
    loading: false,
    arquivoValido: true,
    arquivoFaltante: [],
    dialogFile: true,
    conteudoPlanilha: null,
    erroPlanilha: null,
    valid: true,
    disable: true,
    dialogInfoCotacao: false,
    dialogProgress: false,
    mostrarDialogRestricaoTecnica: false,
    mostrarBloqueio: false,
    snack: false,
    snackColor: "",
    snackText: "",
    tipoPessoaList: [
      { id: 1, titulo: "Física" },
      { id: 2, titulo: "Jurídica" }
    ],
    eventArquivo: null,
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    },
    corretor: {
      dataVencimentoApolice: null,
      cnpj: null,
      idCiaRenovacao: null,
      idPropostaTipo: null,
      descricao: null,
      razaoSocial: null,
      detentorApolice: true,
      idStatusCorretorReserva: 1,
      idTipoPessoa: null
    },
    formCorretorValidado: true,
    idCorretor: null,
    clickImportar: false,
    statusCorretorReservaList: [],
    regras: {
      cpf: [v => !!String(v).match(/^\d{11}$/) || "Valor incorreto"],

      notNull: [
        v =>
          !!(v instanceof Array ? v.length : v !== null) ||
          "Você não pode deixar este campo em branco"
      ],
      length: len => v =>
        (v || "").length <= len ||
        `Número máximo de caractéres ultrapassado, requer no máximo ${len} caractéres.`
    },
    simOuNao: [
      {
        value: true,
        titulo: "Sim"
      },
      {
        value: false,
        titulo: "Não"
      }
    ],
    dateInicio: null,
    erro: null,
    propostaTipoList: [],
    ciaRenovacaoList: []
  }),
  props: {
    atualizarCorretoresProps: {
      type: Function
    }
  },
  watch: {
    "corretor.cnpj"(val) {
      this.disableProximo();
    },
    "corretor.razaoSocial"(val) {
      this.disableProximo();
    },
    "corretor.idCiaRenovacao"(val) {
      this.disableProximo();
    },
    "corretor.dataVencimentoApolice"(val) {
      this.disableProximo();
    },
    "corretor.detentorApolice"(val) {
      this.disableProximo();
    },
    "corretor.idTipoPessoa"(val) {
      this.disableProximo();
    },
    "corretor.idPropostaTipo"(val) {
      if(val == 3) {
        this.corretor.dataVencimentoApolice = new Date().toISOString().slice(0, 10)
      }
    }
  },

  mounted() {
    this.buscarTipoDeProposta();
    this.buscarListaCia();
  },
  computed: {
    textInicio() {
      if (this.dateInicio) {
        return new Date(this.dateInicio).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "long",
          day: "numeric"
        });
      }
    },

    formRulesComputed() {
      return formRules;
    },

    cnpjRules() {
      return this.formRulesComputed.transportadora.cnpj(this.corretor.cnpj);
    },

    cnpjValido() {
      if (!this.corretor.cnpj) return false;
      if (this.corretor.idTipoPessoa === 1) {
        return !!String(this.corretor.cnpj).match(/^\d{11}$/);
      }
      return validadores.validarCNPJ(this.corretor.cnpj);
    }
  },
  methods: {
    fecharDialogAnexo() {
      this.corretor = null;
      this.dialogCotacaoAnexo = false;
      this.dateInicio = null;
      this.arquivo = {};
      this.resetarModel();
    },

    voltarDialogAnexo() {
      this.erro = null;
      this.erroPlanilha = null;
      this.dialogCotacaoAnexo = false;
      this.$emit("voltarDialog");
    },

    salvarPlanilhaModelo() {
      this.$store.commit("startLoading");
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/downloadPlanilhaModelo`, {
          responseType: "arraybuffer",
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          const arquivo = response.data;
          const blob = new Blob([arquivo], {
            type: response.headers["content-type"]
          });
          saveAs(blob, "PlanilhaModelo.xlsx");
        })
        .catch(err => {})
        .finally(() => {
          this.$store.commit("endLoading");
        });
    },

    formatarMensagemErroPlanilha(message) {
      if(message != null) {
        const parts = message.split("O(s) chassi(s) já possuem uma reserva de mercado:");

        if (parts.length === 2) {
            return parts[0].trim() + "\nO(s) chassi(s) já possuem uma reserva de mercado:" + parts[1].trim();

        }
      }
      return message;
    },

    submeterArquivoPlanilha() {
      this.loading = true;
      const formData = new FormData();
      formData.append("planilha", this.arquivo);
      formData.append("cnpj", this.corretor.cnpj);
      axios
        .post(
          `${process.env.URL_PLANILHAMS}/v1/validarPlanilhaCorretor`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response.data) {
            this.arquivoValido =
              typeof response.data.valido === "boolean"
                ? response.data.valido
                : true;
            this.arquivoFaltante =
              response.data.naoEncontrados instanceof Array
                ? response.data.naoEncontrados
                : [];
            this.conteudoPlanilha =
              response.data.conteudo instanceof Array
                ? response.data.conteudo
                : [];
            this.erroPlanilha =
              response.data.erros instanceof Array ? response.data.erros : [];
          }
          if (this.arquivoValido) {
            this.avaliarPlanilha();
            this.clickImportar = !this.clickImportar;
          }
        })
        .catch(error => {
          this.arquivoValido = false;
          this.erro = error.response.data.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    processarArquivo(event) {
      this.arquivo = event.target.files[0];
    },

    avaliarPlanilha() {
      if (!(this.conteudoPlanilha instanceof Array)) {
        return;
      }
      this.dialogProgress = true;
      setTimeout(() => {
        this.$store.commit("formCorretorReserva/setConteudoPlanilha", {
          dados: this.conteudoPlanilha.map(e => {
            const item = this.erroPlanilha.find(v => v.item === e.item);
            return { ...e, erro: item && item.erro };
          })
        });
        this.$store.commit("formCorretorReserva/setDadosCorretorReserva", {
          dataVencimentoApolice: this.corretor.dataVencimentoApolice,
          cnpj: this.corretor.cnpj,
          idCiaRenovacao: this.corretor.idCiaRenovacao ? this.corretor.idCiaRenovacao : 202,
          idPropostaTipo: this.corretor.idPropostaTipo,
          descricao: null,
          razaoSocial: this.corretor.razaoSocial,
          detentorApolice: this.corretor.detentorApolice,
          idStatusCorretorReserva: this.corretor.idStatusCorretorReserva,
          idTipoPessoa: this.corretor.idTipoPessoa
        });

        this.$store.commit("formCorretorReserva/setErroPlanilha", {
          dados: this.erroPlanilha
        });

        this.dialogProgress = false;
        this.snackbar.visivel = true;
        this.snackbar.sucesso = true;
        this.snackbar.mensagem = "Arquivo importado com sucesso";
        this.dialogInfoCotacao = true;
      }, 5000);
    },

    resetarModel() {
      this.corretor.dataVencimentoApolice = null;
      this.corretor.cnpj = null;
      this.corretor.idCiaRenovacao = "";
      this.corretor.idPropostaTipo = "",
      this.corretor.descricao = "";
      this.corretor.razaoSocial = "";
      this.corretor.detentorApolice = "";
      this.dateInicio = "";
      this.corretor.idTipoPessoa = null;
      this.corretor.idStatusCorretorReserva = "";
      this.arquivo = {};
      this.mostrarBloqueio = false;
    },

    async submeterArquivo(id) {
      this.loading = true;
      const formData = new FormData();
      formData.append("arquivoCorretor", this.arquivo[0]);
      await axios
        .post(
          `${process.env.URL_CORRETORMS}/v1/salvaArquivoCorretorReserva/${id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response) {
            this.arquivoValido =
              typeof response.data.valido === "boolean"
                ? response.data.valido
                : true;
            this.save();

            setTimeout(() => {
              this.resetarModel();
              this.dialogCotacaoAnexo = false;
            }, 1000);
          }
        })
        .catch(error => {
          this.arquivoValido = false;
          this.erro = error.response.data.message;
        })
        .finally(() => {
          this.loading = false;
          this.$emit("atualizar");
        });
    },

    submeterArquivosList(id) {
      this.loading = true;
      const formData = new FormData();
      for (var i = 0; i < this.$refs.file.files.length; i++) {
        let file = this.$refs.file.files[i];
        formData.append("arquivoCorretorReserva", file);
      }
      axios
        .post(
          `${process.env.URL_CORRETORMS}/v1/salvaArquivosCorretorReserva/${id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response) {
            this.arquivoValido =
              typeof response.data.valido === "boolean"
                ? response.data.valido
                : true;
            this.save();
            setTimeout(() => {
              this.resetarModel();
              this.dialogCotacaoAnexo = false;
            }, 1000);
          }
        })
        .catch(error => {
          this.arquivoValido = false;
          this.erro = error.response.data.message;
        })
        .finally(() => {
          this.$emit("atualizar");
          this.loading = false;
        });
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo com sucesso.";
    },

    disableProximo() {
      if (this.corretor.idPropostaTipo == 3) {
        this.corretor.idCiaRenovacao = "";
        this.corretor.dataVencimentoApolice = "";
      }

      const campoVazio = (v) => v == null || v === undefined || v === "";
      const cnpjVazio = campoVazio(this.corretor.cnpj);
      const razaoSocialVazia = campoVazio(this.corretor.razaoSocial) || (this.corretor.razaoSocial && this.corretor.razaoSocial.length <= 0);
      const tipoPessoaVazio = campoVazio(this.corretor.idTipoPessoa);
      const tipoPropostaVazio = campoVazio(this.corretor.idPropostaTipo);

      const isNovaNegocio = this.corretor.idPropostaTipo == 3;
      const ciaRenovacaoVazia = !isNovaNegocio && campoVazio(this.corretor.idCiaRenovacao);
      const dataVencimentoVazia = !isNovaNegocio && campoVazio(this.corretor.dataVencimentoApolice);
      const detentorApoliceVazio = this.corretor.detentorApolice == null || this.corretor.detentorApolice === undefined || this.corretor.detentorApolice === "";

      const cnpjTamanhoMinimo = this.corretor.idTipoPessoa === 1
        ? (this.corretor.cnpj && this.corretor.cnpj.length === 11)
        : (this.corretor.cnpj && this.corretor.cnpj.length === 14);

      if (
        cnpjVazio || !cnpjTamanhoMinimo ||
        razaoSocialVazia ||
        tipoPessoaVazio ||
        tipoPropostaVazio ||
        ciaRenovacaoVazia ||
        dataVencimentoVazia ||
        detentorApoliceVazio
      ) {
        this.disable = true;
      } else {
        this.disable = false;
      }
    },

    modalAtualizar() {
      this.dialogInfoCotacao = false;
      this.dialogCotacaoAnexo = false;
      this.$emit("atualizar");
      this.resetarModel();
    },

    proximaPagina() {
      if (!this.$refs.formulario.validate()) {
        return;
      }
      this.verificarBloqueioCnpjCpf();
    },

    verificarBloqueioCnpjCpf() {
      this.mostrarBloqueio = false;
      axios
        .get(`${process.env.URL_ESSORMS}/v1/bloqueio-cnpjcpf?cpfCnpj=${this.corretor.cnpj}`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          if (response.data && response.data.bloqueado === true) {
            this.mostrarBloqueio = true;
          } else {
            this.verificarListaSuja();
          }
        })
        .catch(err => {
          console.error("Erro ao verificar bloqueio de CPF/CNPJ: ", err);
          this.verificarListaSuja();
        });
    },

    verificarListaSuja() {
      axios
        .get(`${process.env.URL_ESSORMS}/v1/restricao-tecnica?cpfCnpj=${this.corretor.cnpj}&tipoPessoa=${this.corretor.idTipoPessoa}`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          if (response.data.estaRestrito === true) {
            this.mostrarDialogRestricaoTecnica = true;
          } else {
            this.$emit("fecharDialog", this.corretor);
            this.dialogCotacaoAnexo = true;
          }
        })
        .catch(err => {
          console.error("Ocorreu um erro ao verificar a lista suja: ", err);
        });
    },

    processarArquivo(event) {
      this.arquivo = event.target.files[0] || {};
    },

    fecharDialog() {
      this.$emit("fechar");
      this.corretor = {};
      this.dateInicio = null;
      this.arquivo = {};
      this.erro = null;
      this.mostrarBloqueio = false;
      this.$refs.formulario.reset()
    },

    onDateChange: function() {
      this.dateInicio = this.corretor.dataVencimentoApolice;
      this.corretor.dataVencimentoApolice = this.corretor.dataVencimentoApolice
    },

    buscarListaCia() {
      axios
        .get(`${process.env.URL_CORRETORMS}/v1/ciaRenovacao`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.ciaRenovacaoList =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    },

    buscarTipoDeProposta() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/apoliceTipoDeProposta`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.propostaTipoList =
            response.data instanceof Array ? response.data : [];
        })
        .catch(err => {
          console.error(err);
        });
    }
  }
};
</script>

<style>
  .table-grid thead {
    background-color: #00456e;
  }
  .table-grid .column {
    color: #fff !important;
  }

  .table-grid th i {
    color: #fff !important;
  }

  .dialog {
    background: #eaeaea !important;
  }

  .headline {
    color: #fff;
    font-size: 14px !important;
  }

  .text-error {
    color: #f45353;
    font-weight: bold;
  }

  .text-error-custom {
    color: #f45353;
    font-size: 12px;
    font-weight: bold;
    white-space: pre-line;
    margin-bottom: 2px;
  }

  .name-arquivo {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px 10px;
    background-color: #fff;
    border-radius: 2px;
  }

  input[type="file"] {
    display: none;
  }

  .button-custom {
    width: 100%;
    max-width: 121px;
    text-align: center;
    color: #fff !important;
    background-color: #00456e;
    border-radius: 2px;
    display: inline-block;
    padding: 9px 12px;
    cursor: pointer;
    font-weight: bold;
  }
  .button-custo:not(.v-btn--disabled) {
    color: #fff !important;
  }
  .button-custom.v-btn--disabled {
    background-color: #cccccc !important;
    color: #666666 !important;
  }
  .button-custom-label {
    width: 100%;
    min-width: 100px;
    text-align: center;
    color: #fff !important;
    background-color: #2bb4b6;
    border-radius: 2px;
    display: inline-block;
    padding: 9px 12px;
    cursor: pointer;

    font-weight: bold;
  }

  .button-custom:hover {
    background-color: #063f57;
  }

  .disabled,
  .v-btn.button-custom:disabled {
    cursor: default;
    background-color: #063f57;
    color: #aaaaaa !important;
  }

  .disabled:hover {
    background-color: #063f57;
  }

  .click {
    cursor: pointer;
  }
  .size {
    size: 1;
  }
  .radio-inputs-cotacao .v-input--selection-controls.v-input .v-label {
    color: #555555;
  }

  .border-container {
    display: block;
    border: 2px solid #c9c9c9;
    height: 180px;
    max-height: 180px;
    padding: 8px;
    overflow-y: scroll;
  }
  .relatorio-erros-titulo {
    margin-bottom: 0;
    font-size: 14px;
    font-weight: bold;
    color: #6d6d6d;
  }

  .bloqueio-alerta {
    background-color: #fdf3d0;
    color: #7a5b00;
    border-radius: 4px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/ModalCotacao.vue